interface StepChipProps {
  index: number;
  text: string;
}

const StepChip: React.FC<StepChipProps> = ({ index, text }) => {
  return (
    <div className="flex flex-col gap-3 text-start">
      <div className="font-bold text-5xl">
        {index} <span className="text-primary"> . </span>
      </div>
      <div className="text-gray-500"> {text} </div>
    </div>
  );
};

export default StepChip;
